import { ParameterType } from '@/study-search/enums';
import { DegreeTypeFilterOptionValue, DurationFilterOptionValue } from '@studyportals/search-filters';
import { TitleBase } from './TitleBase';

export default class TitleCountryDegreeTypeOneYear extends TitleBase {
	private countryValue: string;
	private degreeTypeValue: string;
	private degreeTypeOptionValue: DegreeTypeFilterOptionValue;
	private durationValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);
		this.durationValue = this.getFilterValue(ParameterType.DURATION);
		this.degreeTypeOptionValue = this.filters.find((_) => _.type === ParameterType.DEGREE_TYPE)
			?.values[0] as DegreeTypeFilterOptionValue;

		return (
			this.indexableFilters.length === 3 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some(
				(_) =>
					_.type === ParameterType.DEGREE_TYPE &&
					((_.values[0] as DegreeTypeFilterOptionValue) === DegreeTypeFilterOptionValue.MSC ||
						(_.values[0] as DegreeTypeFilterOptionValue) === DegreeTypeFilterOptionValue.MBA)
			) &&
			this.indexableFilters.some(
				(_) =>
					_.type === ParameterType.DURATION &&
					(_.values[0] as DurationFilterOptionValue) === DurationFilterOptionValue.ONE_YEAR
			)
		);
	}

	protected getPageTitle(): string {
		return `${this.durationValue} ${this.degreeTypeValue} degrees in ${this.countryValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		if (this.degreeTypeOptionValue === DegreeTypeFilterOptionValue.MSC) {
			return `Discover ${this.totalSearchResults} ${this.durationValue} ${degreeTypeValue} in ${this.countryValue}`;
		}

		return `Explore ${this.totalSearchResults} ${this.durationValue} ${degreeTypeValue} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		if (this.degreeTypeOptionValue === DegreeTypeFilterOptionValue.MSC) {
			return (
				`Explore a range of ${this.durationValue} MSc programs in ${this.countryValue}. ` +
				`Gain expertise swiftly and launch your career with these accelerated degrees.`
			);
		}
		return (
			`Find ${this.durationValue} MBA options in ${this.countryValue}. Boost your career with a fast, focused business degree. ` +
			`Find your perfect study with ${this.portalName}.`
		);
	}
}
